export default "__VITE_ASSET__CM_RjjXP__"